export enum OrganizationDetailTabs {
  Users = 0,
  Products = 1,
  Transformations = 2,
  ExternalAuth = 3,
}

export type RouteParams = { id: string };
